import { RhLink } from "@components";
import classNames from "classnames/bind";
import { getLinkData } from "@/core/utils";
import ExternalArrow from "@/assets/svg/external-arrow.svg";
import ArrowTailRight from "@/assets/svg/arrow-tail-right-no-padding.svg";
import { TopLevelNavigation } from "@header";

import styles from "./Links.module.scss";
const cx = classNames.bind(styles);

type TopLevelLinkProps = TopLevelNavigation[number];

export default function TopLevelLink(props: TopLevelLinkProps) {
  const { link } = props;
  const linkData = getLinkData(link);
  const Icon = link?.linkType?.[0] === "external" ? ExternalArrow : ArrowTailRight;
  if (!linkData) return null;

  return (
    <RhLink
      className={cx("top-level-link")}
      href={linkData.url}
      target={linkData.target}
      data-gtm-section="nav"
    >
      <p className="title-uc-s">{linkData.label}</p>
      <Icon className={cx("icon")} />
    </RhLink>
  );
}
